/**
 * Query param names Amplify treats as an OAuth response (`code`/`error` in the
 * search string; `state` accompanies `code`).
 */
const OAUTH_RESPONSE_PARAMS = ['code', 'state', 'error'];

/** Whether a URL search string carries an OAuth response for Amplify to handle. */
export const isOAuthResponse = (search: string): boolean => {
	const params = new URLSearchParams(search);

	return OAUTH_RESPONSE_PARAMS.some((name) => params.has(name));
};
